import React from 'react';
// template components
import BulletedList from '@nmx/template/dist/componentLibrary/components/BulletedList';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => (
  <SectionContainer
    id='life-insurance-faq-receive-one-bill-for-multiple-payments'
    backgroundVariant='lightA'
    themeType='lightTheme'>
    <Row align='center'>
      <Col medium={8}>
        <Typography
          component='h2'
          nextElement='typography'
          align='center'>
          Receive One Bill For Multiple Policies
        </Typography>
        <Typography
          component='h3'
          nextElement='typography'>
          If you have several policies with Northwestern Mutual, you can save time and energy by opening a Billing Account.
        </Typography>
        <Typography nextElement='typography'>
          With an Billing Account you can:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Consolidate premiums from two or more insurance policies. Payments for up to 15 policies can be combined on one bill.' },
            { bulletText: 'Make regular installment payments on loans or policies.' },
            { bulletText: <>Pay premiums by automatic withdrawal &#40;Electronic Funds Transfer&#41; from your checking or savings account.</> },
            { bulletText: <>Pay premiums online with Northwestern Mutual&#39;s secure online payment option.</> },
            { bulletText: <>Pay premiums on a convenient schedule, monthly, quarterly, semi&#45;annually, or annually.</> },
            { bulletText: <>Earn interest on any additional funds that accumulate in your Insurance Service Account.&#42; &#40;Billing Account Plus only&#41;</> },
          ]}
        />
        <Typography nextElement='typography'>
          <strong> Note: </strong>
          A separate account is required for variable products and annuity products.
        </Typography>
        <Typography nextElement='typography'>
          &#42;A variable Insurance Service Account cannot accumulate surplus and therefore cannot earn interest.
        </Typography>
        <Typography nextElement='typography'>
          To sign up for an Billing Account Plus:
        </Typography>
        <BulletedList
          bulletedListData={[
            { bulletText: 'Call your Northwestern Mutual' },
            {
              bulletText: (<>
                <>Contact Northwestern Mutual directly:</>
                <BulletedList
                  bulletedListData={[
                    {
                      bulletText: <>Telephone: <Link
                        id='life-insurance-faq-one policy-for-multiple-policies-toll-free-number-link'
                        ariaLabel='Call to sign up for billing account plus'
                        linkUrl='tel:8003888123'
                        variant='primaryDeemphasize'>
                        1&#45;800&#45;388&#45;8123
                      </Link>, <time dateTime='7:00-06:00'>7am</time>&#8211;<time dateTime='18:00-06:00'>6pm</time> CT, Monday &#8211; Friday</>,
                    },
                    {
                      bulletText: <>Fax: <Link
                        id='life-insurance-faq-sign-up-billing-toll-free-number-link'
                        ariaLabel='Fax number for billing account plus'
                        linkUrl='tel:4146259000'
                        variant='primaryDeemphasize'>
                        1&#45;414&#45;625&#45;9000
                      </Link>.</>,
                    },
                  ]}
                  bulletType='disc' />
              </>),
            },
          ]}/>
      </Col>
    </Row>
  </SectionContainer>
);
